import React from 'react';

function Footer() {
  return (
    <footer style={{
      backgroundColor: '#1e1e1e',
      color: '#ccc',
      padding: '20px 10px',
      fontSize: '14px',
      textAlign: 'center',
      borderTop: '1px solid rgba(198,165,140,0.3)',
    }}>
      <div style={{ marginBottom: '8px' }}>
        &copy; {new Date().getFullYear()} Pyramid Construction. جميع الحقوق محفوظة.
      </div>

      <div>
        Design: <a 
          href="https://www.facebook.com/share/1GCNH4sWyZ/"  // <-- استبدل بالرابط الحقيقي للفيس بوك
          target="_blank" 
          rel="nofollow" 
          style={{
            color: '#f4c542',
            textDecoration: 'none',
            fontWeight: '600',
          }}
        >
          Mohamed Alaa
        </a>
      </div>

      <style>{`
        footer a:hover {
          color: #fff;
          text-decoration: underline;
        }
      `}</style>
    </footer>
  );
}

export default Footer;
